import React, { useState, useEffect, useRef } from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Paper from '@mui/material/Paper';
import FormGroup from '@mui/material/FormGroup';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import InfoIcon from '@mui/icons-material/Info';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import CreatorsDialog from './CreatorsDialog';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DialogContent from '@mui/material/DialogContent';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MuvikaService from './../../services/muvika';
import IconButton from '@mui/material/IconButton';
import PitchButtons from '../items/PitchButtons';
import FormControl from '@mui/material/FormControl';
import accountStore from '../../stores/account';
import AddSinger from './../dialogs/AddSinger';
import InputLabel from '@mui/material/InputLabel';
import messageStore from './../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import { Views } from './../../enums/enums';
import Link from '@mui/material/Link';
import DialogPlayer from '../player/DialogPlayer';
import searchStore from '../../stores/search';
import navigationStore from '../../stores/navigation';

function ChangeTrackPerformance(props) {

  const singerRef = useRef(null);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const setError = messageStore((state) => state.setError);
  const account = accountStore((state) => state.account);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const addSingerLocally = singersStore((state) => state.addSingerLocally);

  const itemsOnPage = 25;
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = searchStore((state) => state.search);
  const setOnlyArtist = searchStore((state) => state.setOnlyArtist);

  const getInitPitch = () => {
    if (props.track && props.performance && account.tags.includes("consumer")) {
      return props.track.last_pitch ? props.track.last_pitch : props.performance.pitch;
    }
    return 0;
  };

  const [currentSinger, setCurrentSinger] = useState(props.performance.profile);
  const [currentSingerName, setCurrentSingerName] = useState(null);
  const [currentPitch, setCurrentPitch] = useState(getInitPitch());
  const [creators, setCreators] = useState(null);

  const [isAddSingerOpen, setIsAddSingerOpen] = useState(false);

  const handleOpenAddSinger = () => {
    setIsAddSingerOpen(true);
  };

  const handleCloseAddSinger = () => {
    setIsAddSingerOpen(false);
  };

  useEffect(() => {
    getCreators();
  }, []);

  useEffect(() => {
    if (props.open) {
      setCurrentSinger(props.performance.profile);
      setCurrentSingerName(props.performance.profile.name);
      setCurrentPitch(getInitPitch());
    }
  }, [props.open]);

  const getCreators = () => {
    if (props.track) {
      if (props.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.track.track_id)
          .then(function (res) {
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const singerList = () => {
    if (props.singers) {
      return props.singers.map((singer, index) =>
        <MenuItem key={singer.id} value={singer.id}>{singer.name}</MenuItem>
      );
    }
  };

  const handleSingerChange = (event) => {
    if (props.singers) {
      let singerId = event.target.value;
      let singer = props.singers.find(x => x.id == singerId);
      if (singer) {
        setCurrentSinger(singer);
      }
    }
  };

  const handleSingerSet = (event) => {
    let singerName = event.target.value;
    setCurrentSingerName(singerName);
  };

  const handlePitchChange = (event, newPitch) => {
    setCurrentPitch(newPitch);
  };

  const handleSingerCreation = (singerName, gender, email) => {
    if (singerName) {
      singerName = singerName.trim();
      if (singerName.length > 0) {
        MuvikaService.createSinger(sessionToken, singerName, gender, email)
          .then(function (res) {
            if (res.data.data) {
              addSingerLocally(res.data.data);
              if (res.data.data.id) {
                setCurrentSinger(res.data.data);
              } else {
                setError(sessionToken, 0, TR.cm_failed_to_create_singer);
              }
            }
          })
          .catch(function () { });
        setIsAddSingerOpen(false);
      } else {
        setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
      }
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const changeTrackPerformance = () => {
    if (account) {
      if (settings.singer_selection === "type") {
        let singerName = currentSingerName;
        if (singerName) {
          singerName = singerName.trim();
          if (singerName.length > 0) {
            MuvikaService.createSinger(sessionToken, singerName, "", "")
              .then(function (res) {
                //console.log(res);
                if (res.data.data) {
                  addSingerLocally(res.data.data);
                  if (res.data.data.id) {
                    let createdSinger = res.data.data;
                    setCurrentSinger(createdSinger);
                    props.onChangeTrackPerformance(createdSinger, currentPitch);
                  } else {
                    setError(sessionToken, 0, TR.cm_failed_to_create_singer);
                  }
                }
              })
              .catch(function () { });
          } else {
            setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
          }
        } else {
          setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
        }
      } else {
        props.onChangeTrackPerformance(currentSinger, currentPitch);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (isAddSingerOpen) {
        handleSingerCreation();
      } else if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      } else {
        changeTrackPerformance();
      }
    }
  };

  const renderAddSingerButton = () => {
    if (settings) {
      if (settings.singer_selection === "list") {
        return <IconButton className="muvika-dialog-plus-button" color="white" component="label" onClick={handleOpenAddSinger}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const singerForm = () => {
    if (settings) {
      if (settings.singer_selection === "type") {
        return <FormGroup>
          <InputLabel>{TR.cm_singer}</InputLabel>
          <TextField
            size="small"
            inputRef={singerRef}
            className="muvika-dialog-name"
            autoFocus
            onFocus={event => {
              event.target.select();
            }}
            margin="dense"
            type="email"
            fullWidth
            value={currentSingerName}
            onChange={handleSingerSet}
          />
        </FormGroup>;
      }
    }
    if (currentSinger) {
      return <FormGroup>
        <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
        <Grid container spacing={0}>
          <Grid item xs={10.5}>
            <Select
              className="muvika-dialog-select"
              labelId="new-singer-label"
              label={TR.cm_singer}
              value={currentSinger.id}
              onChange={handleSingerChange}
            >
              {singerList()}
            </Select>
          </Grid>
          <Grid item xs={1.5}>
            {renderAddSingerButton()}
          </Grid>
        </Grid>
      </FormGroup>;
    } else {
      if (props.singers?.length > 0) {
        return <FormGroup>
          <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <Select
                className="muvika-dialog-select"
                labelId="new-singer-label"
                label={TR.cm_singer}
                value={props.singers[0].id}
                onChange={handleSingerChange}
              >
                {singerList()}
              </Select>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddSingerButton()}
            </Grid>
          </Grid>
        </FormGroup>;
      } else {
        return <FormGroup>
          <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <p className="muvika-no-singers">{TR.cm_no_singers}</p>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddSingerButton()}
            </Grid>
          </Grid>
        </FormGroup>;
      }
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.Search);
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.track} />
      <AddSinger open={isAddSingerOpen} isPerformanceAdd={true} onClose={handleCloseAddSinger} onSingerCreation={handleSingerCreation} />
      <DialogContent>
        <DialogPlayer track={props.track}/>
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.track.artist}
          </Link> - {props.track.title} ({props.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
        </h4>
        <Stack spacing={5}>
          {singerForm()}
          <Paper className="muvika-pitch-buttons">
            <p className="muvika-pitch-title">
              {TR.cm_key_pitch}
            </p>
            <PitchButtons value={currentPitch} onPitchChange={handlePitchChange} />
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={changeTrackPerformance}>{TR.cm_change}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default ChangeTrackPerformance;